<script>
    export let hoverable = true
</script>

<style>

    .outer-box {
        transition: 0.2s;
        background-color: #fff;
		border: 1px solid #f6f6f6;
		border-radius: 8px;
		box-shadow: 1px 1px 5px #2e2a3611;
		padding: 0.5rem 1.5rem;
        margin: 0;
        box-sizing: border-box;
        height: 100%;
        /* overflow: auto; */
        display: grid;
        grid-template-rows: auto;
    }

	.box {
        height: auto;
        padding: 1rem 0.5rem;
        box-sizing: border-box;
        align-self: stretch;
    }

    .hoverable:hover {
        transform: translate(-1px, -5px);
        box-shadow: 1px 4px 5px #2e2a3622;
    }

    .accessories {
        width: auto;
        /* overflow: auto; */
        align-self: end;
    }

    .left-accessory {
        float: left;
    }

    .right-accessory {
        float: right;
    }



</style>

<div class:hoverable class="outer-box">
    <div class="box">
	    <slot></slot>
    </div>
    <div class="accessories">
        <slot name='accessory'></slot>
        <div class="left-accessory">
            <slot name='left-accessory'></slot>
        </div>
        <div class="right-accessory">
            <slot name='right-accessory'></slot>
        </div>
    </div>
</div>